import { z } from 'zod';

export const VariantJSONSchema = z.object({
	accountId: z.uuidv4(),
	enabled: z.boolean(),
});

export type IVariantJSON = z.infer<typeof VariantJSONSchema>;
